module.exports = __webpack_public_path__ + "assets/tutorials/Naming_Your_Test.png";